
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Map = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 13 20" {...props} className={ modClassName }>
      <g>
        <g transform="translate(-441.000000, -907.000000)">
          <g transform="translate(435.000000, 904.000000)">
            <path d="M12.5,3 C16.0935714,3 19,6.05175 19,9.825 C19,14.94375 12.5,22.5 12.5,22.5 L12.0185185,21.9165799 C10.5138889,20.0489583 6,14.090625 6,9.825 C6,6.05175 8.90642857,3 12.5,3 Z M12.5,4.5 C9.75166667,4.5 7.5,6.86425 7.5,9.825 C7.5,10.7698783 7.79337834,11.9426582 8.35456421,13.2800343 C8.87917207,14.5302404 9.61662176,15.8778239 10.5119324,17.271151 C11.0604099,18.1247191 11.6417479,18.9551428 12.2295373,19.7411634 L12.5,20.097 L12.7704627,19.7411634 C13.2113047,19.1516479 13.6485179,18.5371558 14.0709608,17.9066554 L14.4880676,17.271151 C15.3833782,15.8778239 16.1208279,14.5302404 16.6454358,13.2800343 C17.2066217,11.9426582 17.5,10.7698783 17.5,9.825 C17.5,6.86425 15.2483333,4.5 12.5,4.5 Z M12.5,7.3875 C13.7820896,7.3875 14.8214286,8.47880592 14.8214286,9.825 C14.8214286,11.1711941 13.7820896,12.2625 12.5,12.2625 C11.2179104,12.2625 10.1785714,11.1711941 10.1785714,9.825 C10.1785714,8.47880592 11.2179104,7.3875 12.5,7.3875 Z"></path>
          </g>
        </g>
      </g>
    </IconBase>);
};

Map.defaultProps = {
  title: 'Map',
};

export default Map;
